var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "m0 128 256-32 256 32v256l-256 32L0 384Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M0 0h512v128H0zm0 384h512v128H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 304h-16v-80h16zm128 0h16v-80h-16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208,
    cy: 296,
    rx: 48,
    ry: 32
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    x: 128,
    y: 192,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    x: 272,
    y: 192,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24v-24h-24z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 208,
    fill: "#ff9811",
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 208,
    fill: "#ff9811",
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 304,
    fill: "#ff9811",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 304,
    fill: "#ff9811",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M160 272v24c0 8 4 14 9 19l5-6 5 10a21 21 0 0 0 10 0l5-10 5 6c6-5 9-11 9-19v-24h-9l-5 8-5-8h-10l-5 8-5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 252h172m-172 24h28m116 0h28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M122 248a4 4 0 0 0-4 4 4 4 0 0 0 4 4h172a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0 24a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm144 0a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M196 168c-7 0-13 5-15 11l-5-1c-9 0-16 7-16 16s7 16 16 16c7 0 13-4 15-11a16 16 0 0 0 17-4 16 16 0 0 0 17 4 16 16 0 1 0 10-20 16 16 0 0 0-27-5c-3-4-7-6-12-6zm0 8c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm24 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm-44 10 4 1 4 8c0 4-4 7-8 7s-8-3-8-8c0-4 4-8 8-8zm64 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-7l4-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M220 284v12c0 7 5 12 12 12s12-5 12-12v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M200 160h16v32h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M208 224h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24zm-88 16h48v48h-48z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 32,
    x: 222,
    y: 232,
    fill: "#d80027",
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M168 232v8h8v16h-8v8h32v-8h-8v-16h8v-8zm8-16h64v8h-64z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 202,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 202,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 202,
    r: 6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M169 272v43a24 24 0 0 0 10 4v-47h-10zm20 0v47a24 24 0 0 0 10-4v-43h-10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#338af3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 272,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 264,
    y: 320,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    x: 120,
    y: 320,
    ry: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.6027bab7e6243cd17f3b0cac8cff01c6.svg";
export { ForwardRef as ReactComponent };